import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons/download-blue.svg'
import _imports_1 from '@/assets/img/icons/add-user-black.svg'
import _imports_2 from '@/assets/img/icons/user-circle.svg'
import _imports_3 from '@/assets/img/icons/reload-circle.svg'
import _imports_4 from '@/assets/img/icons/check-circle.svg'
import _imports_5 from '@/assets/img/icons/add-participant.svg'
import _imports_6 from '@/assets/img/icons/visibility.svg'
import _imports_7 from '@/assets/img/icons/outgoing-mail.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-59579187"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between mb-8" }
const _hoisted_2 = { class: "text-xl leading-7 font-semibold tracking-wider text-blue-900 mb-2" }
const _hoisted_3 = { class: "text-sm leading-6 text-gray-400 mb-2" }
const _hoisted_4 = { class: "relative inline-block text-left" }
const _hoisted_5 = { class: "flex gap-3 items-start" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_9 = { class: "border-b border-gray-400 mb-6" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "grid grid-cols-4 gap-4"
}
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "text-xl leading-7 font-semibold tracking-wider text-blue-900 mb-6" }
const _hoisted_14 = { class: "flex justify-center gap-2" }
const _hoisted_15 = { class: "rounded-2xl flex p-1 bg-gray-100" }
const _hoisted_16 = { class: "mx-1 text-xs leading-5 font-semibold text-blue-900" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_18 = { class: "rounded-2xl flex p-1 bg-gray-100" }
const _hoisted_19 = { class: "mx-1 text-xs leading-5 font-semibold text-yellow-500" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_21 = { class: "rounded-2xl flex p-1 bg-gray-100" }
const _hoisted_22 = { class: "mx-1 text-xs leading-5 font-semibold text-green-600" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col items-center justify-center my-10 gap-2"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "w-32 h-32 mb-4"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Anda belum menambahkan peserta", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_29 = { class: "flex gap-3" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_table_lite = _resolveComponent("table-lite")!
  const _component_resend_email_invitation_modal = _resolveComponent("resend-email-invitation-modal")!
  const _component_success_create_project_modal_molecules = _resolveComponent("success-create-project-modal-molecules")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_back_button),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.state.projectData.name), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formatDateTime(
                _ctx.state.projectData.started_at,
                "DD MMMM YYYY [00:00]"
              )) + " - " + _toDisplayString(_ctx.formatDateTime(_ctx.state.projectData.ended_at, "DD MMMM YYYY [23:59]")), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                type: "button",
                class: _normalizeClass(["status-button inline-flex justify-center border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 rounded-full leading-5 tracking-wide", 
                  'status-button--' + _ctx.getBadgeVariant(_ctx.state.projectData.status)
                ])
              }, _toDisplayString(_ctx.state.projectData.status_label), 3),
              (!_ctx.isDoneStatus(_ctx.state.projectData.status))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "ml-2 text-blue-900 text-sm underline",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleStatusDropdown && _ctx.toggleStatusDropdown(...args)))
                  }, " Ganti Status "))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_button_dropdown, {
              show: 
                _ctx.showStatusDropdown && !_ctx.isDoneStatus(_ctx.state.projectData.status)
              ,
              items: _ctx.statusDropdownItems,
              onSelectItem: _ctx.selectStatusDropdown
            }, null, 8, ["show", "items", "onSelectItem"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadReport && _ctx.downloadReport(...args))),
          disabled: _ctx.isDownloadingReport,
          class: "px-4 py-2 bg-transparent border-1 border-gray-300 rounded text-blue-900 text-sm leading-6 font-semibold flex items-center gap-3"
        }, [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.isDownloadingReport ? "Downloading.." : "Download Excel"), 1)
        ], 8, _hoisted_6),
        (_ctx.showAddBtn(_ctx.state.projectData.status))
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isDraft(_ctx.state.projectData.status) ? 'span' : 'router-link'), {
              key: 0,
              tag: "button",
              to: `/admin/project/${_ctx.state.projectData.id}/invite`,
              title: _ctx.isDraft(_ctx.state.projectData.status) ? 'Status masih draft' : '',
              class: _normalizeClass([
            _ctx.isDraft(_ctx.state.projectData.status)
              ? 'cursor-not-allowed opacity-60'
              : 'cursor-pointer'
          , "px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3"])
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createTextVNode(" Tambah Peserta ")
              ]),
              _: 1
            }, 8, ["to", "title", "class"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.id,
          class: _normalizeClass([_ctx.activeTab === tab.id && 'border-blue-700 font-semibold', "px-8 py-2 border-b-2 border-transparent text-base leading-6 tracking-wider text-blue-700"]),
          onClick: ($event: any) => (_ctx.setActiveTab(tab.id))
        }, _toDisplayString(tab.label), 11, _hoisted_10))
      }), 128))
    ]),
    (_ctx.activeTab === 'assessment')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.projectData.bundles, (assessment) => {
            return (_openBlock(), _createElementBlock("div", {
              key: assessment.id,
              class: "border rounded-2xl p-4 text-center"
            }, [
              _createVNode(_component_router_link, {
                to: `/admin/project/${_ctx.state.projectData.id}/test/${assessment.id}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: assessment.image,
                    alt: `${assessment.name} image`,
                    class: "w-20 h-20 bg-gray-300 my-4 mx-auto rounded-full"
                  }, null, 8, _hoisted_12),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(assessment.name), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(assessment.total_invitation), 1),
                      _hoisted_17
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(assessment.total_ongoing), 1),
                      _hoisted_20
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(assessment.total_done), 1),
                      _hoisted_23
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
          (!_ctx.table.isLoading && !_ctx.state.projectData.participants.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                _hoisted_27,
                (_ctx.showAddBtn(_ctx.state.projectData.status))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isDraft(_ctx.state.projectData.status) ? 'span' : 'router-link'), {
                      key: 0,
                      tag: "button",
                      to: `/admin/project/${_ctx.state.projectData.id}/invite`,
                      title: _ctx.isDraft(_ctx.state.projectData.status) ? 'Status masih draft' : '',
                      class: _normalizeClass([
            _ctx.isDraft(_ctx.state.projectData.status)
              ? 'cursor-not-allowed opacity-60'
              : 'cursor-pointer'
          , "px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3"])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28,
                        _createTextVNode(" Tambah Peserta ")
                      ]),
                      _: 1
                    }, 8, ["to", "title", "class"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(_component_table_lite, {
                key: 1,
                "is-loading": _ctx.table.isLoading,
                "is-static-mode": true,
                "is-slot-mode": true,
                columns: _ctx.table.columns,
                rows: _ctx.table.rows,
                total: _ctx.state.projectData.participants.length,
                sortable: _ctx.table.sortable
              }, {
                total_bundle_done: _withCtx((data) => [
                  _createTextVNode(_toDisplayString(data.value.total_bundle_done) + " / " + _toDisplayString(data.value.bundles.length), 1)
                ]),
                created_by: _withCtx((data) => [
                  _createTextVNode(_toDisplayString(data.value.created_by.name), 1)
                ]),
                action: _withCtx((data) => [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      class: "flex-shrink-0",
                      onClick: ($event: any) => (_ctx.actionView(data.value.id))
                    }, _hoisted_32, 8, _hoisted_30),
                    _createElementVNode("button", {
                      class: "flex-shrink-0",
                      onClick: ($event: any) => (_ctx.actionResendEmail(data.value.id))
                    }, _hoisted_35, 8, _hoisted_33)
                  ])
                ]),
                _: 1
              }, 8, ["is-loading", "columns", "rows", "total", "sortable"]))
        ])),
    _createVNode(_component_resend_email_invitation_modal, {
      ref: "showResendEmailModal",
      participantId: _ctx.resendEmailParticipantId
    }, null, 8, ["participantId"]),
    _createVNode(_component_success_create_project_modal_molecules, {
      ref: "showSuccessCreateProjectModal",
      projectId: _ctx.state.projectData?.id
    }, null, 8, ["projectId"])
  ]))
}